import { BundleData, ProductData } from '../../../shared/types/graphql-types';

export function getProductSubtotal(
  quantity: number,
  product: ProductData,
  shouldSkipMapPrice = false
) {
  let price;

  if (product?.mapRuleSatisfied && product?.mapPrice && !shouldSkipMapPrice) {
    if (product?.mapDisplayRule?.mapPriceDisplay === false) {
      price = undefined;
    } else {
      price = product?.mapPrice?.value;
    }
  } else {
    price = product?.price?.value;
  }

  return (price ?? 0) * (quantity || 0);
}

export function getPrebuiltSubtotal(
  quantity: number,
  prebuilt: BundleData,
  shouldSkipMapPrice = false
) {
  const prebuiltQuantity = 4;
  let price1;
  let price2;

  if (prebuilt?.product1) {
    price1 = getProductSubtotal(
      prebuiltQuantity,
      prebuilt.product1,
      shouldSkipMapPrice
    );
  }

  if (prebuilt?.product2) {
    price2 = getProductSubtotal(
      prebuiltQuantity,
      prebuilt.product2,
      shouldSkipMapPrice
    );
  }

  const finalPrice = price1 + price2;

  return finalPrice * (quantity || 0);
}
